<script setup lang="ts">
/** components */
import TheLoader from '~/components/TheLoader.vue'
import CarouselEvent from '~/components/market-insights/CarouselEvent.vue'
import CarouselVideo from '~/components/market-insights/CarouselVideo.vue'
import CarouselArticle from '~/components/market-insights/CarouselArticle.vue'

/** types */
import useAuthStore from '~/stores/auth'

/** types */
import type { TEventHero } from '~/src/types/events'
import type { TCommon } from '~/src/types/common'

/** props */
withDefaults(
  defineProps<{
    loading?: boolean
    market?: string
    articles?: TCommon[]
    videos?: TCommon[]
    events?: TEventHero[]
  }>(),
  {
    loading: true,
    market: '',
    articles: () => [],
    events: () => [],
    videos: () => [],
  },
)

/** app */
defineEmits<{
  'play-video': [item: TCommon]
}>()

const authStore = useAuthStore()
</script>

<template>
  <div
    :key="authStore.jwtToken"
    class="relative grid h-full grid-cols-1 grid-rows-2 gap-4 md:h-96 md:grid-cols-2"
  >
    <div v-if="loading" class="absolute inset-0">
      <TheLoader />
    </div>
    <template v-else>
      <CarouselArticle
        v-if="articles.length"
        :market="market"
        :articles="articles"
        line-clamp-class="line-clamp-5"
        class="row-span-2 h-[380px] md:h-full"
      />
      <div class="h-[180px] md:h-full">
        <CarouselVideo
          v-if="videos.length"
          :videos="videos"
          class="h-full"
          @play="$emit('play-video', $event)"
        />
      </div>
      <div class="h-[180px] md:h-full">
        <CarouselEvent v-if="events.length" :events="events" class="h-full" />
      </div>
    </template>
  </div>
</template>
